import * as React from "react";

interface AlertType {
    message: any;
    open: boolean;
    variants: "alert-warning" | "alert-success" | "alert-danger";
}

export interface AlertConsumerType {
    alert: AlertType;
    setAlert: (alert: AlertType) => AlertType;
}

export const AlertContext = React.createContext({
    alert: { open: false, variants: "alert-warning", message: "enter message" },
    setAlert: (alert: any) => {
        return alert;
    },
});

export class AlertProvider extends React.Component {
    // Context state
    state: any = {
        alert: {
            open: false,
            variants: "alert-warning",
            message: "enter message",
        },
    };

    // Method to update state
    setAlert = (alert: AlertType) => {
        this.setState((prevState) => ({ alert }));
    };

    render() {
        const { children } = this.props as any;
        const { alert } = this.state;
        const { setAlert } = this;

        return (
            <AlertContext.Provider
                value={{
                    alert,
                    setAlert,
                }}
            >
                {children}
            </AlertContext.Provider>
        );
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.state.alert.open) {
            setTimeout(
                () =>
                    this.setAlert({
                        ...this.state.alert,
                        open: false,
                    }),
                10000
            );
            //console.log("this.state.alert", this.state.alert);
        }
    }
}

export const AlertConsumer: any = AlertContext.Consumer;



// WEBPACK FOOTER //
// ./ClientApp/components/AlertContext.tsx